var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H10.5V25.5H7.5V10.5ZM21 10.5H22.5V25.5H21V10.5ZM15 10.5H19.5V25.5H15V10.5ZM12 10.5H13.5V25.5H12V10.5ZM24 10.5H28.5V25.5H24V10.5Z",
    fill: "#437057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5H12V4.5H6C4.3455 4.5 3 5.8455 3 7.5V13.5H6V7.5ZM6 31.5H12V28.5H6V22.5H3V28.5C3 30.1545 4.3455 31.5 6 31.5ZM30 4.5H24V7.5H30V13.5H33V7.5C33 5.8455 31.6545 4.5 30 4.5ZM30 28.5H24V31.5H30C31.6545 31.5 33 30.1545 33 28.5V22.5H30V28.5Z",
    fill: "#437057"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditem);
export default __webpack_public_path__ + "static/media/additem.c9109b416f66934f042fac2f163c5d4a.svg";
export { ForwardRef as ReactComponent };